import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  updatePropsMyActiveMentenancePlannigs,
  updatePropsMyHistoryMentenancePlannigs,
} from '../../../../contextRedux/MentenancePlanning/MentenancePlanningModel';
import MyActiveMentenancePlanning from './ActiveMentenancePlanning/MyActiveMentenancePlanning';
import HistoryMentenancePlanning from './HistoryMentenancePlanning/MyHistoryMentenancePlanning';

const ManageMyMentenancePlanning: React.FC = () => {
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState<string>('Mentenante Active');

  // Function to dispatch common state updates for both active and history tabs
  const dispatchTabData = (isActiveTab: boolean) => {
    const commonActions = [
      { field: 'searchTerm', value: '' },
      { field: 'skip', value: 0 },
      { field: 'take', value: 10 },
    ];

    // Dispatch common actions
    commonActions.forEach(({ field, value }) => {
      dispatch(updatePropsMyActiveMentenancePlannigs({ field, value }));
      dispatch(updatePropsMyHistoryMentenancePlannigs({ field, value }));
    });

    // Dispatch specific action for active or history tab
    const tabActions = isActiveTab ? { field: 'refresh', value: true } : { field: 'refresh', value: true };

    dispatch(
      isActiveTab
        ? updatePropsMyActiveMentenancePlannigs(tabActions)
        : updatePropsMyHistoryMentenancePlannigs(tabActions)
    );
  };

  // Effect to handle tab change
  useEffect(() => {
    if (activeKey === 'Mentenante Active') {
      dispatchTabData(true); // Active tab
    } else if (activeKey === 'Istoric') {
      dispatchTabData(false); // History tab
    } else {
      dispatchTabData(true); // Default to active tab
    }
  }, [activeKey, dispatch]);

  // Tab item configuration
  const tabItems = [
    {
      key: 'Mentenante Active',
      label: 'Mentenante Active',
      children: <MyActiveMentenancePlanning />,
    },
    {
      key: 'Istoric',
      label: 'Istoric',
      children: <HistoryMentenancePlanning />,
    },
  ];

  return <Tabs activeKey={activeKey} onChange={setActiveKey} items={tabItems} />;
};

export default ManageMyMentenancePlanning;
